import { employeeSkillsActionTypes } from "./employeeSkillsActionTypes";

const {
  CANCEL_ADD_SKILL,
  ADD_NEW_SKILL_LOADING,
  SKILL_ADD_FAIL,
  SKILL_ADD_SUCCESS,
  SKILL_LIST_LOADING,
  SKILL_LIST_LOAD_SUCCESS,
  SKILL_LIST_LOAD_FAIL,
  DELETE_SKILL_LOADING,
  DELETE_SKILL_SUCCESS,
  DELETE_SKILL_FAIL,
  EDIT_SKILL_VIEW,
  EDIT_SKILL_LOADING,
  EDIT_SKILL_SUCCESS,
  EDIT_SKILL_FAIL,
  CANCEL_EDIT_SKILL,
  FIELDS_STATE_CHANGE,
  CLEAR_FIELDS,
  DELETE_SKILL,
  IS_EDIT_SKILL,
  SKILL_BTN_DISABLE,
  SKILL_BTN_LOADING
} = employeeSkillsActionTypes;

const INITIAL_STATE = {
  skills: [],
  skill: {
    Name: "",
    Notes: ""
  },
  DepartmentId: 0,
  editSkillRecord: {
    Id: 0,
    Name: "",
    Notes: "",
    DepartmentId: 0
  },
  listAllSkills: true,
  addNewSkill: false,
  editSkill: false,
  isLoading: false,
  isValidName: false,
  isValidNotes: false,
  isEditSkill: false,
  EmployeeCount: 0,
  skillBtnLoading: false,
  skillBtnDisable: false,
  error: "",
  depName: ""
};

export default function employeeSkillsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CANCEL_ADD_SKILL:
      return {
        ...state,
        listAllSkills: true,
        addNewSkill: false,
        skill: { Name: "", Notes: "" },
        error: ""
      };
    case SKILL_BTN_LOADING:
      return { ...state, skillBtnLoading: action.val };
    case SKILL_BTN_DISABLE:
      return { ...state, skillBtnDisable: action.val };
    case IS_EDIT_SKILL:
      return { ...state, isEditSkill: action.val };
    case FIELDS_STATE_CHANGE:
      return { ...state, isValidSkillName: true, isValidSkillNotes: true };
    case ADD_NEW_SKILL_LOADING:
      return { ...state, isLoading: true, error: "" };
    case SKILL_ADD_FAIL:
      return { ...state, error: action.payload, isLoading: false };
    case SKILL_ADD_SUCCESS:
      return {
        ...state,
        error: "",
        isLoading: false,
        isValidSkillName: false,
        isValidSkillNotes: false,
        listAllSkills: true,
        addNewSkill: false,
        skill: { Name: "", Notes: "" }
      };
    case SKILL_LIST_LOADING:
      return { ...state, isLoading: true };
    case SKILL_LIST_LOAD_SUCCESS:
      return {
        ...state,
        skills: action.payload,
        isValidSkillName: false,
        isValidSkillNotes: false,
        isLoading: false
      };
    case SKILL_LIST_LOAD_FAIL:
      return {
        ...state,
        error: action.payload,
        isValidSkillName: false,
        isValidSkillNotes: false,
        isLoading: false
      };
    case EDIT_SKILL_VIEW:
      return {
        ...state,
        listAllSkills: false,
        editSkill: true,
        editSkillRecord: action.record
      };
    case CANCEL_EDIT_SKILL:
      return {
        ...state,
        listAllSkills: true,
        editSkill: false,
        editSkillRecord: {},
        error: ""
      };
    case EDIT_SKILL_LOADING:
      return { ...state, isLoading: true };
    case EDIT_SKILL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isValidSkillName: false,
        isValidSkillNotes: false,
        editSkill: false,
        listAllSkills: true
      };
    case EDIT_SKILL_FAIL:
      return {
        ...state,
        isLoading: false,
        isValidSkillName: false,
        isValidSkillNotes: false,
        error: action.payload
      };
    case DELETE_SKILL_LOADING:
      return { ...state, isLoading: true, error: "" };
    case DELETE_SKILL_SUCCESS:
      return { ...state, isLoading: false, error: "" };
    case DELETE_SKILL_FAIL:
      return { ...state, isLoading: false, error: action.payload };
    case CLEAR_FIELDS:
      return {
        ...state,
        skill: { Name: "", Notes: "" },
        error: "",
        isValidName: false,
        isValidNotes: false
      };
    case DELETE_SKILL:
      return {
        ...state,
        skills: [...state.skills.filter(s => s.Id !== action.skill.Id)]
      };

    default:
      return state;
  }
}
